'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SalesProposalAppIcon = function SalesProposalAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: '0 0 101.6 107.6',
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }), React__default["default"].createElement("style", null, '.prefix__st2{fill:transparent}'), React__default["default"].createElement("g", {
    id: 'prefix__Layer_2'
  }, React__default["default"].createElement("defs", null, React__default["default"].createElement("path", {
    id: 'prefix__SVGID_13_',
    d: 'M-6907.3-29674.5H4437.5V9636.4H-6907.3z'
  })), React__default["default"].createElement("clipPath", {
    id: 'prefix__SVGID_2_'
  }, React__default["default"].createElement("use", {
    xlinkHref: '#prefix__SVGID_13_',
    overflow: 'visible'
  })), React__default["default"].createElement("defs", null, React__default["default"].createElement("path", {
    id: 'prefix__SVGID_15_',
    d: 'M-6907.3-29674.5H4437.5V9636.4H-6907.3z'
  })), React__default["default"].createElement("clipPath", {
    id: 'prefix__SVGID_4_'
  }, React__default["default"].createElement("use", {
    xlinkHref: '#prefix__SVGID_15_',
    overflow: 'visible'
  })), React__default["default"].createElement("defs", null, React__default["default"].createElement("path", {
    id: 'prefix__SVGID_17_',
    d: 'M-6907.3-29674.5H4437.5V9636.4H-6907.3z'
  })), React__default["default"].createElement("clipPath", {
    id: 'prefix__SVGID_6_'
  }, React__default["default"].createElement("use", {
    xlinkHref: '#prefix__SVGID_17_',
    overflow: 'visible'
  })), React__default["default"].createElement("g", null, React__default["default"].createElement("defs", null, React__default["default"].createElement("path", {
    id: 'prefix__SVGID_19_',
    d: 'M-6907.3-29674.5H4437.5V9636.4H-6907.3z'
  })), React__default["default"].createElement("clipPath", {
    id: 'prefix__SVGID_8_'
  }, React__default["default"].createElement("use", {
    xlinkHref: '#prefix__SVGID_19_',
    overflow: 'visible'
  }))), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    className: 'prefix__st2',
    d: 'M26.7 84.9c0 1.5-1.2 2.8-2.8 2.8-1.5 0-2.8-1.2-2.8-2.8 0-1.5 1.2-2.8 2.8-2.8 1.6.1 2.8 1.3 2.8 2.8z'
  }), React__default["default"].createElement("path", {
    className: 'prefix__st2',
    d: 'M11 68.5v28.7c0 3.2 2.6 5.9 5.9 5.9h67.8c3.3 0 5.9-2.6 5.9-5.9V68.5H11zm12.9 21.7c-2.9 0-5.2-2.3-5.2-5.2 0-2.9 2.4-5.2 5.2-5.2 2.9 0 5.2 2.4 5.2 5.2.1 2.8-2.3 5.2-5.2 5.2zm55.9-.7H34V87h45.8v2.5zm0-6.6H34v-2.5h45.8v2.5zM26.7 22.9c0 1.5-1.2 2.8-2.8 2.8-1.5 0-2.8-1.2-2.8-2.8 0-1.5 1.2-2.8 2.8-2.8 1.6.1 2.8 1.3 2.8 2.8z'
  }), React__default["default"].createElement("path", {
    className: 'prefix__st2',
    d: 'M84.7 4.4H16.9C13.7 4.4 11 7 11 10.3v29h79.6v-29c0-3.3-2.7-5.9-5.9-5.9zM23.9 28.2c-2.9 0-5.2-2.4-5.2-5.2 0-2.9 2.4-5.2 5.2-5.2 2.9 0 5.2 2.4 5.2 5.2.1 2.8-2.3 5.2-5.2 5.2zm55.9-.7H34V25h45.8v2.5zm0-6.6H34v-2.5h45.8v2.5z'
  }), React__default["default"].createElement("path", {
    d: 'M92.6 10.3v29h-2v-29c0-3.2-2.6-5.9-5.9-5.9H16.9C13.7 4.4 11 7 11 10.3v29H9v-29c0-4.4 3.5-7.9 7.9-7.9h67.8c4.3 0 7.9 3.5 7.9 7.9zM92.6 68.5v28.7c0 4.4-3.5 7.9-7.9 7.9H16.9c-4.4 0-7.9-3.5-7.9-7.9V68.5h2v28.7c0 3.2 2.6 5.9 5.9 5.9h67.8c3.3 0 5.9-2.6 5.9-5.9V68.5h2z'
  }), React__default["default"].createElement("path", {
    d: 'M34 18.4h45.8v2.5H34zM34 25h45.8v2.5H34z'
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    d: 'M23.9 17.7c-2.9 0-5.2 2.4-5.2 5.2 0 2.9 2.4 5.2 5.2 5.2 2.9 0 5.2-2.4 5.2-5.2.1-2.9-2.3-5.2-5.2-5.2zm0 8c-1.5 0-2.8-1.2-2.8-2.8 0-1.5 1.2-2.8 2.8-2.8 1.5 0 2.8 1.2 2.8 2.8 0 1.6-1.2 2.8-2.8 2.8z'
  })), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    d: 'M34 80.4h45.8v2.5H34zM34 87h45.8v2.5H34z'
  })), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    d: 'M23.9 79.7c-2.9 0-5.2 2.4-5.2 5.2 0 2.9 2.4 5.2 5.2 5.2 2.9 0 5.2-2.3 5.2-5.2.1-2.9-2.3-5.2-5.2-5.2zm0 8c-1.5 0-2.8-1.2-2.8-2.8 0-1.5 1.2-2.8 2.8-2.8 1.5 0 2.8 1.2 2.8 2.8 0 1.6-1.2 2.8-2.8 2.8z'
  })), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    className: 'prefix__st2',
    d: 'M96 39.3H5.6c-2.3 0-4.2 1.9-4.2 4.2v20.8c0 2.3 1.9 4.2 4.2 4.2H96c2.3 0 4.2-1.9 4.2-4.2V43.5c0-2.3-1.9-4.2-4.2-4.2zm2.1 25c0 1.2-1 2.1-2.1 2.1H5.6c-1.2 0-2.1-1-2.1-2.1V43.5c0-1.2 1-2.1 2.1-2.1H96c1.2 0 2.1 1 2.1 2.1v20.8z'
  }), React__default["default"].createElement("path", {
    d: 'M96 41.4H5.6c-1.2 0-2.1 1-2.1 2.1v20.8c0 1.2 1 2.1 2.1 2.1H96c1.2 0 2.1-1 2.1-2.1V43.5c0-1.1-.9-2.1-2.1-2.1zM21.8 60.5l-3.7-7.3 1.2-.6.4-.2.8-.4 1.5 2.9 3.4-5.5 1.3-2.1 1.2.8 1.2.7-7.3 11.7zm64.1-2.2H34v-2.8h51.9v2.8zm0-7.5H34V48h51.9v2.8z'
  })), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    className: 'prefix__st2',
    d: 'M34 48h51.9v2.8H34zM34 55.5h51.9v2.8H34z'
  })), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    className: 'prefix__st2',
    d: 'M29.2 48.8l-7.4 11.7-3.7-7.2 1.2-.7.5-.2.8-.4 1.5 2.9 3.4-5.5 1.3-2.1 1.2.8z'
  })))));
};

var SalesProposalAppIcon$1 = iconStyles()(SalesProposalAppIcon);

module.exports = SalesProposalAppIcon$1;
